import { Component, OnInit } from '@angular/core';
import { favoriteStops } from '@app/constants';

@Component({
  selector: 'ty-view-favorites',
  templateUrl: './view-favorites.component.html',
  styleUrls: ['./view-favorites.component.scss'],
})
export class ViewFavoritesComponent implements OnInit {
  favoriteStops: any[] = [];
  constructor() {}
  ngOnInit(): void {
    const data = JSON.parse(localStorage.getItem(favoriteStops) || '{}');
    this.favoriteStops = Object.keys(data).map((key) => data[key]);
    // console.log(this.favoriteStops, "favorite");
  }
  routeColor(color: string) {
    return `#${color}`;
  }

  navigateTo(url: string) {
    window.location.href = url;
  }
}
